
export default [
	{
		path: '/',
		redirect: '/home',
		component: () => import('@/views'),
		children: [
			{
				name: '首页',
				path: 'home',
				component: () => import('@/views/home')
			},
			{
				name: '产品介绍',
				path: 'product',
				redirect: '/product/organization',
				component: () => import('@/views/product'),
				children: [
					{
						name: '机构版',
						path: 'organization',
						component: () => import('@/views/product/organization')
					},
					{
						name: '个人版',
						path: 'personal',
						component: () => import('@/views/product/personal')
					},
				]
			},
			{
				name: '产品介绍',
				path: 'activity/cater2020',
				component: () => import('@/views/activity/cater2020')
			},
			{
				name: '产品介绍',
				path: 'activity/cater2021',
				component: () => import('@/views/activity/cater2021')
			},
			{
				name: '解决方案',
				path: 'solution',
				redirect: '/solution/weight',
				component: () => import('@/views/solution'),
				children: [
					{
						name: '一站式体重管理解决方案',
						path: 'weight',
						component: () => import('@/views/solution/weight')
					},
					{
						name: '社区营养与健康管理解决方案',
						path: 'community',
						component: () => import('@/views/solution/community')
					}
				]
			},
			{
				name: '联系我们',
				path: 'contact',
				component: () => import('@/views/contact')
			}
		]
	},
	// {
	// 	name: '404',
	// 	path: '/*',
	// 	component: () => import('@/views/404')
	// }
]